var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monit-page wrapper-cards"},[_c('div',{staticClass:"container-cards"},_vm._l((_vm.farmsStatus),function(farm){return _c('farms-status-card',{key:farm.port,attrs:{"item":farm}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }